/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-20 17:49:15
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-09 16:11:22
 * @FilePath: /unifyxp-v2-store-portal/src/request/mediaLibrary/index.ts
 */
import { get, post, remove } from 'src/tools/server';

export const deleteResource = (list: Array<string>) => {
  console.log(list, 'list');
  return remove<any>(`/portal/mediaLibraries/delete`, { data: list });
};

export const searchResource = (
  startIndex: number,
  pageCount: number,
  body: any,
) => {
  return post<any>(
    `/portal/mediaLibraries/${startIndex}/${pageCount}`,
    body,
    {},
  );
};

export const getResourceList = (
  startIndex: number,
  pageCount: number,
  body: any,
) => {
  return post<any>(
    `/portal/mediaLibrarySearch/${startIndex}/${pageCount}`,
    body,
    {},
  );
};

export const createInstance = (sourceUuid: string, body: any) => {
  return post<any>(
    `/portal/mediaLibrary/instance/create/${sourceUuid}`,
    body,
    {},
  );
};

export const saveInstance = (uuid: string, body: any) => {
  const formdata = new FormData();
  for (const key in body) {
    formdata.append(key, body[key]);
  }
  return post<any>(`/portal/mediaLibrary/instance/save/${uuid}`, formdata, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// /portal​/mediaLibrary​/instance​/save​/

export const saveToSource = (uuid: string, body: any) => {
  const formdata = new FormData();
  for (const key in body) {
    formdata.append(key, body[key]);
  }
  return post<any>(
    `/portal/mediaLibrary/instance/saveToSource/${uuid}`,
    formdata,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    },
  );
};

export const resourceDetail = (uuid: string) => {
  return get<any>(`/portal/mediaLibrary/retrieve/${uuid}`, {});
};

export const createTag = (body) => {
  return post<any>(`/portal/mediaLibraryTag`, body, {});
};

export const saveSource = (body) => {
  return post<any>(`/portal/mediaLibrary/update`, body, {});
};
